import { render, staticRenderFns } from "./SexoCombobox.vue?vue&type=template&id=6e9c7f8d&scoped=true"
import script from "./SexoCombobox.vue?vue&type=script&lang=js"
export * from "./SexoCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c7f8d",
  null
  
)

export default component.exports